import { render, staticRenderFns } from "./rechargeChatDetails.vue?vue&type=template&id=33fb0ff4&"
import script from "./rechargeChatDetails.vue?vue&type=script&lang=js&"
export * from "./rechargeChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./rechargeChatDetails.vue?vue&type=style&index=0&id=33fb0ff4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports